
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"18"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_43517","data-name":"Group 43517","transform":"translate(-231.25 -22)","stroke":"#6c7395","stroke-width":"1"}},[_c('path',{attrs:{"id":"Path_29894","data-name":"Path 29894","d":"M14.674 14.623l-2.25-2.25 2.25-2.25M6 20.25h12A2.25 2.25 0 0020.25 18V6A2.25 2.25 0 0018 3.75H6A2.25 2.25 0 003.75 6v12A2.25 2.25 0 006 20.25z","transform":"translate(228.25 19)","fill":"rgba(0,0,0,0)","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('line',{attrs:{"id":"Line_1355","data-name":"Line 1355","y2":"17","transform":"translate(235.5 22.5)","fill":"none"}})])])
          )
        }
      }
    